module.exports = __webpack_public_path__ + "assets/fonts/Gordita-Medium.97e2ceaa35cfea3260bef440d7e2212d.woff2";